const Awards = () => {
    return (
        <div id="awards" className="vision-card">
            <h3>AWARDS & MEDALS</h3>
            <p>
                Students have achieved recognition in academics, sports,
                olympiads, debates, and cultural competitions.
            </p>
        </div>
    );
};

export default Awards;